import { useQuery } from "@apollo/client";
import { MY_HR_GET_GENDERS } from "my-hr/graphql";

export interface OcGender {
  code: string;
  name: string;
}
export const useOcGenders = () => {
  const { data, loading, error } = useQuery(MY_HR_GET_GENDERS, {
    fetchPolicy: "cache-and-network",
  });

  const result = data?.genders || [];
  return {
    data: result,
    loading,
    error,
  };
};

export default useOcGenders;
